import Vue from "vue";
import Vuex from "vuex";
import AuthModule from "./AuthModule";
import FileModule from "./FileModule";
import ChatModule from "./ChatModule";
import ChatGroupModule from "./ChatGroupModule";



Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    auth: AuthModule,
    file: FileModule,
    chat: ChatModule,
    groupchat: ChatGroupModule
  },
  state: {
    alert_message: null,
    show_tabbar: true,
    quit_application: null
  },
  getters: {
    alert_message: state => state.alert_message,
    quit_application: state => state.quit_application,
    show_tabbar: state => state.show_tabbar
  },
  mutations: {
    setAlertMessage(state, payload) {
      state.alert_message = payload
    },
    setQuitApplication(state, payload) {
      state.quit_application = payload
    },
    setShowTabs(state, payload) {
      state.show_tabbar = payload
    }
  }
});
